import { Box } from '@chakra-ui/react';

import { EquipItem, ScanningItem } from '@app/api/models';
import { FieldView, Txt } from '@app/components/common';
import { TableColumn, dateTimeBodyRender } from '@app/components/common/table';
import GalleryModal from '@app/components/common/modals/gallery';

export const txColumns: TableColumn<ScanningItem>[] = [
  {
    name: 'visit_result_id',
    label: 'ID',
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    name: 'visit_type',
    label: 'Тип',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (value, rowData) => {
        return <>{value?.name || '-'}</>;
      },
    },
  },
  {
    name: 'visit_date',
    label: 'Дата',
    options: {
      filter: {
        type: 'date',
        name: 'visit_date',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, false),
    },
  },
  {
    name: 'equip',
    label: 'ХО',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: EquipItem | null) => {
        if (!value) {return <Txt fontSize='sm' textColor='gray.500'>не определен</Txt>;}
        return <Box>
          <Txt textColor='brand-500'>{value.model?.name}</Txt>
          <Box display='flex' gap={2} fontSize='small' textColor='var(--chakra-colors-gray-500)'>
            <Txt fontSize='small'>{value.inventory_num}</Txt>
            <Box display='flex'>
              <Txt textColor='var(--chakra-colors-gray-700)'>SN: </Txt>
              <Txt>{value.serial_num}</Txt>
            </Box>
          </Box>
        </Box>;
      }
    }
  },
  {
    name: 'equip_active',
    label: 'Исправлено',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: EquipItem | null) => {
        if (!value) {return <Txt fontSize='sm' textColor='gray.500'>нет</Txt>;}
        return <Box display='flex' gap={2} flexDirection='column'>
          <FieldView title="Бренд" value={value.brand?.name} />
          <FieldView title="Модель" value={value.model?.name} />
          <FieldView title="Производитель" value={value.manufacturer?.name} />
          <FieldView title="Серийный номер" value={value.serial_num} />
          <FieldView title="Инв.номер" value={value.inventory_num} />
          <FieldView title="Дата производства" value={value.production_date} />
        </Box>;
      }
    }
  },
  {
    name: 'images',
    label: 'Фото',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: Array<any>) => {
        return <GalleryModal  images={value || []} title="Фото" />;
      },
    },
  },
  {
    name: 'not_equal',
    label: 'Несоответствия',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: Array<string>, { rowData }) => {
        return <>{value.join(', ')}</>;
      },
    },
  },
];